<template>
  <div>
    <div class="row q-pb-xs">
      <span class="midia-app-label-sm"
        v-if="institutionalStore.institutionalDetail?.comentarioAjuste">
        Ajustes Solicitados
      </span>
    </div>

    <div class="row q-py-xs"
      v-if="institutionalStore.institutionalDetail?.comentarioAjuste">
      <c-q-btn
        id="btn-view-requested-adjustments"
        propBtnLabel="Visualizar"
        :propBtnFunction="onViewRequestedAdjustmentsBtnClick"
        :propBtnTransparent="true"
        :propBtnSize="EnumButtonSizes.SMALL"
      />
    </div>
  </div>
</template>


<script setup lang="ts">
import { EnumRequestedAdjustmentsInstitucionalModalType, EnumButtonSizes } from '@/enums/enums'
import { usePagesUtilStore } from '@/stores/pagesUtilStore'
import { useInstitutionalStore } from '@/stores/institutionalStore'

const institutionalStore = useInstitutionalStore()
const pagesUtilStore = usePagesUtilStore()

const onViewRequestedAdjustmentsBtnClick = () => {
  pagesUtilStore.modalRequestedAdjustmentsInstitucionalModalType =
    EnumRequestedAdjustmentsInstitucionalModalType.UPDATE
  pagesUtilStore.showModalRequestAdjustmentsInstitucional = true
}
</script>

<style scoped></style>
